// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z7to","colMin":"styles_colMin__2hpa8"};